<script setup lang="ts">
import { computed } from "vue";
import NavigationIcon from "@magnit/icons/src/assets/icons/navigation-24.svg";
import MinusIcon from "@magnit/icons/src/assets/icons/minus-24.svg";
import PlusIcon from "@magnit/icons/src/assets/icons/plus-24.svg";
import { ShopSelectToolbarButtons } from "../enums";
import type { IToolbarButtonProps } from "../types";

const props = withDefaults(defineProps<IToolbarButtonProps>(), {
  disabled: false,
});
const iconComponent = computed(() => {
  if (props.type === ShopSelectToolbarButtons.GEOLOCATION)
    return NavigationIcon;
  if (props.type === ShopSelectToolbarButtons.ZOOM_IN) return PlusIcon;
  if (props.type === ShopSelectToolbarButtons.ZOOM_OUT) return MinusIcon;
  return NavigationIcon;
});
const className = computed(() => [{ disabled: props.disabled }]);
</script>

<template>
  <button class="shop-select__toolbar__button" :class="className">
    <div class="shop-select__toolbar__button--icon">
      <component :is="iconComponent" />
    </div>
  </button>
</template>

<style lang="postcss" scoped>
.shop-select__toolbar__button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: var(--pl-surface-primary-default);
  width: 44px;
  height: 44px;
  cursor: pointer;
  border-radius: var(--pl-unit-x3);
  margin: var(--pl-unit-x2) 0;
  box-shadow:
    0 6px 22px 0 #4444442e,
    0 1px 3px 0 #bbbbbb14;

  &:hover {
    background: #f1f1f1;
  }

  &:not(.disabled):active {
    box-shadow: none;
  }

  &--icon {
    display: flex;
  }

  &.disabled svg {
    opacity: 0.4;
  }
}
</style>
